// src/api_scripts/get/getAddressBookEntries.js
import { fetchAllPages } from "../paginationUtils";

/**
 * Fetches Address Book Entries for a specific Address Book ID.
 * @param {string} addressBookId - The ID of the Address Book to fetch entries for.
 * @param {string} orgId - The organization ID.
 * @param {string} accessToken - The access token for authentication.
 * @param {Function} setProgress - Function to update the progress log.
 * @returns {Promise<Array>} - A promise that resolves to an array of address book entries.
 */
const getaddressbookEntries = async (addressBookId, orgId, accessToken, setProgress) => {
  // Construct the relative URI using the specific addressBookId
  const relativeUri = `organization/${orgId}/v2/address-book/${addressBookId}/entry`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, `Address Book Entries for ID "${addressBookId}"`);
    
    // Add the addressBookId to each entry for easier reference when mapping to Excel
    const entriesWithBookId = dataArray.map(entry => ({
      ...entry,
      addressBookId: addressBookId, // Store the parent Address Book ID
      // Note: addressBookName would need to be looked up separately if needed
    }));

    console.log(`Get Address Book Entries API Response Data (all pages) for ID "${addressBookId}":`, entriesWithBookId.length, "items");
    return entriesWithBookId;

  } catch (error) {
    console.error(`Error fetching Address Book Entries for Address Book ID "${addressBookId}":`, error);
    throw error;
  }
};

export default getaddressbookEntries;